import { Form, Formik } from 'formik'
import styled from 'styled-components'
import { Button, P, Wrapper } from '@farewill/ui'
import { COLOR, FONT, GTR } from '@farewill/ui/tokens'

import SelectInput from 'components/form/select-input'
import Label from 'components/styled/label'

export type AdminUserOption = {
  label: string
  value: number | 'null'
}

type OwnerAssignmentFormProps = {
  initialAdminUserId: number | null | 'null'
  adminUserOptions: AdminUserOption[]
  isSubmitting?: boolean
  onAssign: (adminUserId: number | null) => Promise<void> | void
  canAssign?: (adminUserId: number | null) => boolean
  header?: string
  showAssignSelfButton?: boolean
  onAssignSelf?: () => void
}

const StyledAssignLeadButton = styled(Button.Secondary)`
  margin-bottom: ${GTR.XS};

  && {
    padding: ${GTR.XS} ${GTR.L};
  }
`

const StyledLabel = styled(Label)`
  display: flex;
  justify-content: space-between;
  font-size: ${FONT.SIZE.S};
  font-weight: ${FONT.WEIGHT.MEDIUM};
`

const StyledAssignSelfButton = styled(Button.Underline)`
  font-size: ${FONT.SIZE.S};
  padding: 0;
`

const OwnerAssignmentForm = ({
  initialAdminUserId,
  adminUserOptions,
  isSubmitting = false,
  onAssign,
  canAssign = (adminUserId) => adminUserId !== null,
  header,
  showAssignSelfButton = false,
  onAssignSelf,
}: OwnerAssignmentFormProps) => {
  return (
    <Formik
      initialValues={{ ownedByAdminUserId: initialAdminUserId }}
      onSubmit={() => {
        //
      }}
    >
      {({ values }) => {
        const selectedAdminUserId =
          values.ownedByAdminUserId === 'null'
            ? null
            : values.ownedByAdminUserId
        const shouldShowAssign = canAssign(selectedAdminUserId)

        return (
          <Form style={{ cursor: 'default' }}>
            {header && (
              <P color={COLOR.GREY.DARK} strong>
                {header}
              </P>
            )}
            <StyledLabel $error={false}>
              <span>Select owner</span>
              {showAssignSelfButton && onAssignSelf && (
                <StyledAssignSelfButton type="button" onClick={onAssignSelf}>
                  Assign yourself
                </StyledAssignSelfButton>
              )}
            </StyledLabel>
            <SelectInput
              name="ownedByAdminUserId"
              options={adminUserOptions}
              small
            />
            <Wrapper centered margin={['S', 0, 0]}>
              {shouldShowAssign && (
                <StyledAssignLeadButton
                  type="button"
                  wide
                  loading={isSubmitting}
                  onClick={() => onAssign(selectedAdminUserId)}
                >
                  Assign
                </StyledAssignLeadButton>
              )}
            </Wrapper>
          </Form>
        )
      }}
    </Formik>
  )
}

export default OwnerAssignmentForm
